import React, {Component} from 'react';
import {
    Route,
    NavLink,
    Link
} from "react-router-dom";
import Paper from '@material-ui/core/Paper'
import Dropzone from 'react-dropzone'
import {database} from '../firebaseconfig.js'
import FieldTextArea from '@atlaskit/field-text-area'
import AsyncButton from '../components/AsyncButton'
import {storage} from "../firebaseconfig";


export default class Courses extends React.Component {
    render() {
        return (
            <div className="container">
                <Route path="/students/courses/:courseID/content" component={CourseContent}/>
            </div>
        )
    }
}


class CourseContent extends React.Component {
    render() {
        console.log(this.props)
        return (
            <div className='row'>
                <div className='col-3 col-md-3 col-lg-2 col-xl-2' style={{padding: '10px', borderRight: "1px solid rgba(0,0,0,.1)"}}>
                    <ul className='sticky-top'>
                        {courseContent.map(each => (
                            <li>
                                <a href={`#${each.id}`}>
                                    <small>{each.title}</small>
                                </a>
                            </li>
                        ))}

                    </ul>
                </div>
                <div className='col'>
                    {courseContent.map((each,index) =>
                        <div style={{margin: '20px 10px'}}>
                            <div id={each.id} style={{padding: '10px'}}>
                                <h5 style={{color: '#6772e5'}}>{index + 1}. {each.title}</h5>
                                {each.content}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

const beforeStart = () => {
    return (
        <div>
        <p>
            Download Anaconda <a href="https://www.anaconda.com/distribution/" target="_blank"><u>here</u></a>.
            Anaconda is the package manager for several data science tools, including Python and its associated data science packages.
        </p>
            <p>
                Follow the recommended installation steps but <strong>do not</strong> install VS Code.
            </p>
        </div>

    )
}

const Basics = () => {
    return (
        <a href="https://firebasestorage.googleapis.com/v0/b/parallebs-students.appspot.com/o/codesamples%2FBasics.html?alt=media&token=be745591-6eee-4f78-a542-60527c2b46f2" target="_blank"><i className="fas fa-code"/> Basics Python Codes</a>
    )
}

const Functions = () => {
    return (
        <a href="https://firebasestorage.googleapis.com/v0/b/parallebs-students.appspot.com/o/codesamples%2FControl%20Flow%2C%20Functions%20and%20Class.html?alt=media&token=d16b83f1-042a-412c-8c17-bffbafa9044e" target="_blank"><i className="fas fa-code"/> Control Flow, Function, Class</a>
    )
}

const YelpThai = () => {
    return (
        <div>
            <a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/parallebs-students.appspot.com/o/codesamples%2Fthaifood.json?alt=media&token=ab504a56-0783-49f2-af3b-4458fa7f909a"><i
                className="fas fa-file"/> Yelp Thai Food Dataset (thaifood.json)</a>
        </div>
    )
}

const Pandas = () => {
    return (
        <div>
            <p>
            <a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/parallebs-students.appspot.com/o/codesamples%2FIntro%20to%20Pandas%20DataFrames%201.html?alt=media&token=dbd5319f-d53f-4d84-a43e-6146026f8ddf"><i
                className="fas fa-code"/>DataFrame 1</a>
            </p>
            <p>
                <a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/parallebs-students.appspot.com/o/codesamples%2FDataFrame%202.html?alt=media&token=793bc31a-bf6f-4c96-93dc-753eed8206f9"><i
                    className="fas fa-code"/>DataFrame 1</a>
            </p>

        </div>
    )
}



const DataAnalyticsIntro = () => {
    return (
        <div>
            <h6>HDB Dataset</h6>
            <p>
                <a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/parallebs-students.appspot.com/o/codesamples%2Fhdb_data.csv?alt=media&token=12d8e53c-2ec5-4958-b66a-8dfccdd19bc4"><i className="fas fa-file"/>hdb_data.csv</a>
            </p>
            <h6>Understanding your data</h6>
            <p>
                <a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/parallebs-students.appspot.com/o/codesamples%2FUnderstanding%20the%20data.html?alt=media&token=8b1ac197-e69c-4e59-8493-b66d9de5dbf7"><i className="fas fa-code"/> preprocessing.ipynb</a>
            </p>
            <h6>Train an equation and test it</h6>
            <p>
                <a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/parallebs-students.appspot.com/o/codesamples%2Fregression%20code.ipynb?alt=media&token=8f46d3f7-11cb-4a93-b724-d75fa3943223"><i className="fas fa-code"/>
                    Regression</a>
            </p>
        </div>
    )
}

class Feedback extends React.Component {
    state = {
        feedback: '',
        loading: false
    }

    handleChange = (e) => {
        this.setState({feedback: e.target.value})
    }

    handleSubmit = () => {
        this.setState({loading: true})
        const data = {
            feedback: this.state.feedback,
        }
        database.collection("feedback").add(data)
            .then(() => {
                this.setState({loading: false})
            })
    }

    render() {
        return (
            <div>
                <FieldTextArea
                    autoFocus
                    value={this.state.feedback}
                    label="Feedback"
                    shouldFitContainer
                    onChange={(e) => this.handleChange(e)}
                />
                <div style={{marginTop: '20px', backgroundColor: '#'}}>
                    <AsyncButton bgcolor={"#6772e5"} buttonText="Send Feedback" loading={this.state.loading} onClick={this.handleSubmit} />
                </div>
            </div>
        )
    }
}

const courseContent = [
    {
        title: 'Before you start',
        id: 'before-you-start',
        content: beforeStart()
    },
    {
        title: 'Basics',
        id: 'basics',
        content: Basics()
    },
    {
        title: 'Control Flow, Functions and Class',
        id: 'functions',
        content: Functions()
    },
    {
        title: 'Yelp Data for Thai Food',
        id: 'yelp-data',
        content: YelpThai()
    },
    {
        title: 'Exercise 1',
        id: 'exercise-1',
        content:
            <div>
                <a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/parallebs-students.appspot.com/o/codesamples%2Fyelpthai.html?alt=media&token=ae7eaca3-3f78-49fd-a381-97475ccd0907">
                    <i className="fas fa-code"/> yelpthai.html
                </a>
            </div>
    },
    {
        title: 'Intro to Panda Dataframe (modules)',
        id: 'modules',
        content: Pandas()
    },
    {
        title: 'Data Analytics',
        id: 'data-analytics-intro',
        content: DataAnalyticsIntro()
    },
    {
        title: 'Visualisation',
        id: 'visualisation',
        content: <div>Share your visusalisation <a href="/students/share/PythonHDB-30032019" target="_blank">here</a></div>
    },
    {
        title: 'Feedback',
        id: 'feedback',
        content: <div><Feedback/></div>
    },
]






// WEBPACK FOOTER //
// ./src/StudentApp/Course.js